<template>
    <v-row align="center">
        <FormCancellationReason :dialog.sync="dialog" :item="itemEdit" :initialize.sync="initTable" :handleModal="handleModal" v-if="dialog"/>
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="cyan darken-4" @click="nuevoMotivo">
                            <v-icon left>fas fa-plus-square</v-icon>Nuevo motivo
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" md="8" sm="4" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar motivo por nombre" single-inline hide-details @keydown.enter="searchCancellationReason">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>
                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="cancellationReasons" class="elevation-1"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="editarCancellationReason(item)">
                                    <v-list-item-title>
                                        <v-icon small class="mr-2">fas fa-edit</v-icon> Editar motivo
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="eliminarCancellationReason(item)">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="mr-2 red--text">fas fa-trash-alt</v-icon> Borrar motivo
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.module`]="{ item }">
                        {{ moduleLabel(item.module) }}
                    </template>
                    <template v-slot:[`item.deleted`]="{ item }">
                        <v-chip :color="colorstatus(item.deleted)" label x-small dark
                            v-text="item.deleted ? 'Inactivo' : 'Activo'">
                        </v-chip>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import CancellationReasonDataService from '../../service/catalogo/cancellationReason/cancellationReasonDataService'
import FormCancellationReason from '@/components/cancellationReason/FormCancellationReason.vue';
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import { moduleLabel } from '@/utils/cancellationModules';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import { extractMessage } from '@/helpers/errorHelper';
export default {
    name: "ListaCancellationReason",
    components: {
        FormCancellationReason, Columns, PaginationNumber
    },
    mixins: [pagedTableMixin],
    created() {
        this.fetchTableData();
    },
    data() {
        return {
            cancellationReasons: [],
            dialog: false,
            itemEdit: null,
            headers: [
                { text: "Acciones", value: "actions", sortable: false, groupable: false, show: true },
                { text: "ID", align: " d-none", sortable: false, value: "id", visible: false, groupable: false, show: false },
                { text: "Motivo", value: "name", sortable: false, groupable: false, show: true },
                { text: "Modulo", value: "module", sortable: false, groupable: false, show: true },
                { text: "Estatus (g)", value: "deleted", sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        moduleLabel,
        searchCancellationReason() {
            this.doSearch();
        },
        fetchTable(params) {
            return CancellationReasonDataService.getAllCancellationReason(params);
        },
        applyRows({ rows, total, totalPages }) {
            this.cancellationReasons = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que recibe el formulario de alta y edición.
        initTable() {
            this.reload();
        },
        nuevoMotivo() {
            this.itemEdit = null;
            this.dialog = true;
        },
        editarCancellationReason(item) {
            CancellationReasonDataService.show(item.id).then(response => {
                this.itemEdit = response.data;
                this.dialog = true;
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Error al obtener el motivo', text: extractMessage(err), showConfirmButton: false, timer: 3000 });
            });
        },
        eliminarCancellationReason(item) {
            this.$swal({
                title: "Estas seguro?",
                text: "No se podra revertir la decision!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, eliminar!"
            }).then(result => {
                if (result.isConfirmed) {
                    CancellationReasonDataService.delete(item.id).then(rsp => {
                        if (rsp.status === 200) {
                            this.initTable();
                            this.$swal.fire({ icon: 'success', title: 'Motivo eliminado', text: 'El motivo se desactivo correctamente', showConfirmButton: false, timer: 1500 });
                        }
                        if (rsp.status === 400 || rsp.status === 404) {
                            this.$swal.fire({ icon: 'error', title: 'Error al eliminar el motivo', text: rsp.data.message, showConfirmButton: false, timer: 3000 });
                        }
                    }).catch(err => {
                        this.$swal.fire({ icon: 'error', title: 'Error!!', text: extractMessage(err), showConfirmButton: false, timer: 3000 });
                    });
                }
            });
        },
        colorstatus(deleted) { return deleted ? "error" : "success"; },
        handleModal() { this.dialog = !this.dialog; },

    },
    computed: {
        filteredHeaders() { return this.headers.filter(h => h.show); },
    }
}
</script>
